import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mr-8 text-black-lp-300 text-14px" }
const _hoisted_2 = { class: "p-6 flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between" }
const _hoisted_4 = { class: "flex flex-row space-x-3" }
const _hoisted_5 = { class: "flex flex-row space-x-1" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "text-gray-lp-600" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col space-y-3"
}
const _hoisted_9 = { class: "text-gray-lp-600" }
const _hoisted_10 = { class: "flex flex-row space-x-3" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col space-y-3 w-5/5"
}
const _hoisted_12 = { class: "text-gray-lp-600" }
const _hoisted_13 = { class: "pt-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "pt-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DownloadAttachment = _resolveComponent("DownloadAttachment")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Thread = _resolveComponent("Thread")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.ticketID,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Card, { rounded: '2xl rounded-b-md' }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.detailTicket.rcCreatedName) + " - " + _toDisplayString(_ctx.detailTicket.rcCreatedActorName), 1)
                    ]),
                    _createVNode("p", _hoisted_7, _toDisplayString(_ctx.detailTicket.createdAt), 1)
                  ])
                ]),
                _createVNode(_component_Title, {
                  label: "Deskripsi Kendala",
                  fontSize: 20
                }),
                _createVNode("p", null, _toDisplayString(_ctx.detailTicket.rcDescription), 1),
                (!_ctx.checkIsPhotosExist)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('pusatResolusi.create.photoProof')), 1),
                      _createVNode("div", _hoisted_10, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTicket.rcImageFiles, (image) => {
                          return (_openBlock(), _createBlock("div", { key: image }, [
                            image
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: image,
                                  alt: "image",
                                  class: "rounded object-cover cursor-pointer",
                                  style: {"height":"60px","width":"60px"},
                                  onClick: () => _ctx.onPreview(image)
                                }, null, 8, ["src", "onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.checkIsAttachmentExist)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('pusatResolusi.history.attachment')), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTicket.rcAttachment, (attachment, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          attachment
                            ? (_openBlock(), _createBlock(_component_DownloadAttachment, {
                                key: 0,
                                name: `${_ctx.$t('pusatResolusi.history.attachment')} ${index + 1}`,
                                url: attachment,
                                maxLength: 70,
                                dash: false,
                                linked: ""
                              }, null, 8, ["name", "url"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Thread, {
            data: _ctx.threadList,
            dataForum: _ctx.threadList,
            caseId: _ctx.caseId,
            isSolved: _ctx.isSolved,
            isActorId: _ctx.dataProfile
          }, null, 8, ["data", "dataForum", "caseId", "isSolved", "isActorId"])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, { label: "Status" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_Chips, {
                label: _ctx.statusData?.label,
                textColor: _ctx.statusData?.textColor,
                color: _ctx.statusData?.backgroundColor,
                fontsize: 14,
                weight: "medium",
                rounded: ""
              }, null, 8, ["label", "textColor", "color"])
            ])
          ]),
          _: 1
        }),
        _hoisted_14,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pusatResolusi.columnIssueNo'),
          value: _ctx.detailTicket.rcCaseNumber ? _ctx.detailTicket.rcCaseNumber : _ctx.detailTicket.rcTicketNo
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: "Genesis ID",
          value: _ctx.detailTicket.rcTicketNoGenesis
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pusatResolusi.sttIssue'),
          value: _ctx.detailTicket.rcSttNo,
          customStyleValue: "text-red-lp-100 my-1 font-normal break-words"
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pusatResolusi.category')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_Chips, {
                label: _ctx.detailTicket.rcCategory,
                textColor: "text-gray-lp-300",
                fontsize: 14,
                weight: "medium"
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _hoisted_16,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Tanggal Dibuat'),
          value: _ctx.detailTicket.createdAt,
          caption: `${_ctx.detailTicket.rcCreatedName} - ${_ctx.detailTicket.rcCreatedActorName}`
        }, null, 8, ["label", "value", "caption"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pusatResolusi.updatedDate'),
          value: _ctx.detailTicket.updatedAt,
          caption: `${_ctx.detailTicket.rcUpdatedName} - ${_ctx.detailTicket.rcUpdatedActorName}`
        }, null, 8, ["label", "value", "caption"])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.imagePreview,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.imagePreview = $event)),
      data: _ctx.imagePreviews,
      image: _ctx.image
    }, null, 8, ["modelValue", "data", "image"])
  ], 64))
}